import { AppStore } from "./appStore";
import { CommonStore } from "./commonStore";
import { DashboardStore } from "./dashboardStore";
import { CommentStore } from "./dashboardStore/comments";
import { FilterStore } from "./dashboardStore/filters";
import { TicketStore } from "./dashboardStore/tickets";
import { SnapshotStore } from "./dashboardStore/snapshots";
import { LabelStore } from "./labelStore";
import { ReportStore } from "./reportStore";
import { TrustedTokenStore } from "./trustedTokenStore";
import { CommitteeStore } from "./committeeStore";
import { UserStore } from "./userStore";
import { PostscriptStore } from "./superStore/postscript";
import { SchoolStore } from "Stores/superStore/schools";
import { IngestionStore } from "./superStore/ingestion";
import { AttachmentStore } from "Stores/attachmentStore";
import { StrategicPlanStore } from "Stores/strategicPlanStore";
import { HistoryStore } from "Stores/historyStore";
import { MilestoneStore } from "Stores/milestoneStore";
import { BannerStore } from "Stores/bannerStore";
import { StudentStore } from "Stores/studentStore";
import { FeatureGatingStore } from "Stores/featureGating";
import { CoursesCatalogStore } from "./courseStore";
import {NotificationViewerStore} from "./notificationViewersStore";

const commonStore = new CommonStore();
const dashboardStore = new DashboardStore();
const userStore = new UserStore();
const labelStore = new LabelStore();
const studentStore = new StudentStore();
const committeeStore = new CommitteeStore();
const ticketStore = new TicketStore();
const commentStore = new CommentStore();
const trustedTokenStore = new TrustedTokenStore();
export const reportStore = new ReportStore();
export const appStore = new AppStore();
const filterStore = new FilterStore();
const postscriptStore = new PostscriptStore();
const schoolStore = new SchoolStore();
const ingestionStore = new IngestionStore();
const attachmentStore = new AttachmentStore();
const historyStore = new HistoryStore();
const milestoneStore = new MilestoneStore();
const strategicPlanStore = new StrategicPlanStore();
const snapshotStore = new SnapshotStore();
const bannerStore = new BannerStore();
export const featureGatingStore = new FeatureGatingStore();
const coursesCatalogStore = new CoursesCatalogStore();
const notificationViewerStore = new NotificationViewerStore();

export {
    CommonStore,
    DashboardStore,
    UserStore,
    TicketStore,
    CommentStore,
    LabelStore,
    StudentStore,
    CommitteeStore,
    ReportStore,
    AppStore,
    TrustedTokenStore,
    FilterStore,
    PostscriptStore,
    SchoolStore,
    IngestionStore,
    AttachmentStore,
    HistoryStore,
    MilestoneStore,
    StrategicPlanStore,
    SnapshotStore,
    BannerStore,
    FeatureGatingStore,
    CoursesCatalogStore,
    NotificationViewerStore
};

export const stores = {
    commonStore,
    dashboardStore,
    userStore,
    ticketStore,
    commentStore,
    labelStore,
    studentStore,
    committeeStore,
    appStore,
    reportStore,
    trustedTokenStore,
    filterStore,
    postscriptStore,
    schoolStore,
    ingestionStore,
    attachmentStore,
    historyStore,
    milestoneStore,
    strategicPlanStore,
    snapshotStore,
    bannerStore,
    featureGatingStore,
    coursesCatalogStore,
    notificationViewerStore
};

export default stores;
